import React from 'react';
import RoomsHeader from '../RoomsHeader';
import RoomCard from '../RoomCard';
import './RoomsPage.css';
import roomsData from '../../data/rooms.json'

const RoomsPage = () => {
  
  window.scroll(0,0);
  
  return (
    <div className="relative flex min-h-screen w-full flex-col overflow-x-hidden">
      <div className="layout-container flex h-full grow flex-col">
        <main className="flex flex-col items-center w-full">
          <div className="layout-content-container flex flex-col w-full max-w-6xl">
            <RoomsHeader />
            
            <div className="rooms-grid">
              {roomsData.data.map((room) => (
                <RoomCard key={room.id} room={room} />
              ))}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default RoomsPage;